import { render, staticRenderFns } from "./ShowcaseHeaderBanner.vue?vue&type=template&id=6888d340&scoped=true&"
import script from "./ShowcaseHeaderBanner.vue?vue&type=script&lang=js&"
export * from "./ShowcaseHeaderBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6888d340",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6888d340')) {
      api.createRecord('6888d340', component.options)
    } else {
      api.reload('6888d340', component.options)
    }
    module.hot.accept("./ShowcaseHeaderBanner.vue?vue&type=template&id=6888d340&scoped=true&", function () {
      api.rerender('6888d340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/ShowcaseHeaderBanner.vue"
export default component.exports